import styled, { css } from 'styled-components';
import { colors } from '@/globalStyles';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const WizardWrapper = styled.div`
  width: 100%;
  height: 100%;
  
  ${props => {
    if (props.isSmartphone) {
      return props.isLastWizardPage ? css`display: block;` : css`
        display: grid;
        grid-template-rows: max-content 1fr;
        grid-template-columns: 1fr;
      `;
    }
    return css`
      display: grid;
      grid-template-columns: 1fr max-content;
    `;
  }};
`;

export const WrapperGroup = styled.div`
    display: grid;
    width: 100%;
    height: auto;
    grid-template-rows: ${props =>
        props.gridTemplateRows ? props.gridTemplateRows : '40px'};
    grid-template-columns: none;
    margin-bottom: ${props => props.marginBottom || '0px'};
`;

export const WizardPreviewWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

  svg {
    margin: 0;
    width: 480;
    height: 183;
  }

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          svg {
            margin: 1rem;
            width: auto;
            height: auto;
          }
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const WizardSidebarWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 360px;
    height: 100%;
    margin: 0;
    padding: 20px 30px;
    background-color: #f4f4f4;
    overflow: auto;

    ${props => {
      const { core: { targetDevice } } = store.getState();

      switch (targetDevice) {
        case SMARTPHONE: {
          return css`
            width: auto;
            padding: 20px 30px 40px;
          `;
        }
        default: {
          return null;
        }
      }
  }}
`;

export const PanelHeaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 20px 1fr;
  grid-column-gap: 20px;
  align-items: center;
`;

export const OptionWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
`;

export const UsefullNumericalInputWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 50px;
  align-items: center;
  padding: 5px;
`;

export const OptionItem = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: 22px 1fr;
  grid-column-gap: 13px;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
`;

export const Icon = styled.img`
  cursor: pointer;
`;

export const CrossSectionSelection = styled.div`
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    padding-left: 20px;
`;

export const LineSettingWrapperStyled = styled.div`
  margin-top: 20px;
`;

export const LineTypeSelectorWrapperStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px;
  padding: 5px;
`;

export const LineTypeSelectorStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  height: 40px;
  background-color: ${colors.white};
  border-radius: 4px;
`;

export const LineTypeSelectorTabStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 2px solid ${props => props.active ? colors.primary : 'transparent'};
  cursor: pointer;
`;
